<mat-toolbar class="header-toolbar shadow-sm">
    <!-- Left Section -->
    <div class="header-left">
        <div class="page-indicator"></div>
        <h1 class="page-title">
            {{ pageTitle() }}
        </h1>
    </div>

    <!-- Right Section -->
    <div class="header-right">
        <!-- Branch Context Badge -->
        @if (workingBranchId() || showBranchSelector()) {
            <div class="working-branch-badge hidden sm:flex" [class.working-branch-badge--global]="!workingBranchId()">
                <mat-icon>{{ workingBranchId() ? 'store' : 'public' }}</mat-icon>
                <span>{{ workingBranchId() ? workingBranchName() : 'Visión Global' }}</span>
            </div>
        }

        <!-- User Button -->
        <button mat-button [matMenuTriggerFor]="userMenu" class="user-btn">
            <div class="user-avatar-initials">
                {{ userInitials() }}
            </div>
            <div class="user-info-text hidden sm:flex">
                <span class="user-name">{{ userProfile()?.full_name || 'Usuario' }}</span>
                <span class="user-role">{{ userRoleLabel() }}</span>
            </div>
            <mat-icon class="text-slate-400 !m-0 !w-5 !h-5">keyboard_arrow_down</mat-icon>
        </button>

        <!-- User Menu -->
        <mat-menu #userMenu="matMenu" xPosition="before" class="mt-2 rounded-xl custom-menu">
            <div class="px-4 py-3 border-b border-gray-50 mb-1 sm:hidden">
                <div class="font-bold text-gray-800">{{ userProfile()?.full_name }}</div>
                <div class="text-[10px] text-gray-400 uppercase tracking-wider">{{ userRoleLabel() }}</div>
            </div>
            
            <button mat-menu-item disabled>
                <mat-icon class="text-slate-400">account_circle</mat-icon>
                <span>Mi Perfil</span>
            </button>

            @if (showBranchSelector()) {
            <button mat-menu-item [matMenuTriggerFor]="branchMenu">
                <mat-icon class="text-blue-500">sync_alt</mat-icon>
                <span>Cambiar Sucursal</span>
            </button>
            }

            <div class="border-t border-gray-50 my-1"></div>

            <button mat-menu-item (click)="logout()">
                <mat-icon class="text-red-500">logout</mat-icon>
                <span class="text-red-500 font-medium">Cerrar Sesión</span>
            </button>
        </mat-menu>

        <!-- Branch Menu -->
        <mat-menu #branchMenu="matMenu" class="mt-2 rounded-xl custom-menu">
            @if (isOwner()) {
            <button mat-menu-item (click)="selectBranch(null!)" class="mb-1" [class.bg-blue-50]="workingBranchId() === null">
                <mat-icon [class.text-blue-600]="workingBranchId() === null">public</mat-icon>
                <span [class.font-bold]="workingBranchId() === null">Visión Global</span>
                @if (workingBranchId() === null) {
                    <mat-icon class="text-blue-600 !m-0 !ml-auto">check</mat-icon>
                }
            </button>
            }

            @for (branch of branches(); track branch.id) {
            <button mat-menu-item (click)="selectBranch(branch.id)" [class.bg-blue-50]="branch.id === workingBranchId()">
                <mat-icon [class.text-blue-600]="branch.id === workingBranchId()">location_on</mat-icon>
                <span [class.font-bold]="branch.id === workingBranchId()">{{ branch.name }}</span>
                @if (branch.id === workingBranchId()) {
                    <mat-icon class="text-blue-600 !m-0 !ml-auto">check</mat-icon>
                }
            </button>
            }
        </mat-menu>
    </div>
</mat-toolbar>